import { useCallback, useMemo } from 'react';
import { PlacesAddress } from './activity-import-types';

const LOOKUP_TIMEOUT_MS = 8000;

export const useAddressGeocoder = () => {
  const services = useMemo(() => {
    const { google } = window as any;
    if (!google?.maps?.places) return null;
    return {
      autocomplete: new google.maps.places.AutocompleteService(),
      places: new google.maps.places.PlacesService(document.createElement('div')),
    };
  }, []);

  return useCallback(
    (query: string): Promise<PlacesAddress | null> =>
      new Promise((resolve) => {
        if (!services) {
          resolve(null);
          return;
        }
        const timer = setTimeout(() => resolve(null), LOOKUP_TIMEOUT_MS);
        const finish = (address: PlacesAddress | null) => {
          clearTimeout(timer);
          resolve(address);
        };

        services.autocomplete.getPlacePredictions({ input: query }, (predictions: any[] | null) => {
          const prediction = predictions?.[0];
          if (!prediction) {
            finish(null);
            return;
          }
          services.places.getDetails(
            { placeId: prediction.place_id, fields: ['formatted_address', 'geometry'] },
            (place: any) => {
              if (!place?.geometry?.location) {
                finish(null);
                return;
              }
              finish({
                description: place.formatted_address,
                formatted: place.formatted_address,
                placesId: prediction.place_id,
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              });
            }
          );
        });
      }),
    [services]
  );
};
